import CreekChat from './CreekChat.vue'

Vue.component('creek-chat', CreekChat);


// WEBPACK FOOTER //
// ./client/creek-chat.js